const ENV = process.env.NODE_ENV
const DEV_URL = "http://localhost:4000"
const PROD_URL = "https://us-central1-grouptravelres.cloudfunctions.net/api"

export const uri = ENV === "development" ? DEV_URL : PROD_URL
